export const debounce = <T extends (...args: any[]) => any>(func: T, timeout = 300): T => {
  let timer
  return ((...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }) as T
}
